<template>
  <div class="index">
    <div class="container">
      <!-- banner -->
      <div class="banner">
        <img src="/imgs/b1.jpg" alt="电影资讯" />
        <div class="banner-overlay">
          <h1 class="banner-title">探索电影世界</h1>
          <p class="banner-subtitle">最新影讯 · 深度解析 · 行业动态</p>
        </div>
      </div>

      <!-- 主容器 -->
      <div class="index-con">
        <!-- 左侧 -->
        <div class="index-l">
          <!-- 导航 -->
          <div class="index-title">
            <h2><i class="iconfont icon-hot"></i>最新资讯</h2>
            <div class="title-decoration"></div>
          </div>
          
          <!-- 循环项 -->
          <div class="list-item" v-for="(item, index) in this.data" :key="index" @click="gopay(item.id)">
            <div class="item-content">
              <!-- 左侧图片 -->
              <div class="item-img">
                <img :src="item.img" alt="" />
                <div class="item-overlay">
                  <span class="premium-badge">付费阅读</span>
                </div>
              </div>
              <!-- 右侧信息 -->
              <div class="item-info">
                <!-- 标题 -->
                <div class="item-title">{{ item.title }}</div>
                <!-- 标签和时间 -->
                <div class="item-meta">
                  <span class="item-tag">热门</span>
                  <span class="item-time">2元/篇</span>
                </div>
                <!-- 简介 -->
                <div class="item-jj">
                  {{ item.jj }}
                </div>
                <div class="item-action">
                  <button class="read-btn">立即阅读</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 右侧 -->
        <div class="index-r">
          <!-- 标题 -->
          <div class="r-title">
            <span><i class="iconfont icon-flash"></i>实时快讯</span>
            <div class="title-decoration"></div>
          </div>

          <!-- 循环项 -->
          <div class="r-item" v-for="(item, index) in data2" :key="index" @click="gopay()">
            <div class="r-content">
              <!-- 时间线 -->
              <div class="r-timeline">
                <div class="r-dot"></div>
                <div class="r-line"></div>
              </div>
              
              <!-- 内容 -->
              <div class="r-details">
                <!-- 时间 -->
                <div class="r-time">
                  <span>首都电影院</span>
                  <span class="r-date">{{ formatDate() }}</span>
                </div>

                <!-- 标题 -->
                <div class="r-name">
                  <h3>{{ item.title }}</h3>
                </div>

                <!-- 简介 -->
                <div class="r-jj">
                  <p>
                    {{ item.jj }}
                  </p>
                </div>
                
                <div class="r-action">
                  <span class="read-more">查看详情</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <modal title="请付款下载" btnType="1" modalType="middle" :showModal="showModal" @submit="showModal = false"
      @cancel="showModal = false">
      <template v-slot:body>
        <div class="payment-content">
          <div class="payment-icon">
            <i class="iconfont icon-premium"></i>
          </div>
          <img src="/imgs/pay.png" class="payment-qr" />
          <p class="payment-text">扫码支付：<span class="price">2元</span></p>
          <p class="payment-desc">解锁完整内容阅读权限</p>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "./../components/Modal.vue";
export default {
  components: {
    Modal,
  },
  data() {
    return {
      data: [],
      data2:[],
      showModal: false,
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.init();
    document.title = "首都电影院";
  },
  methods: {
    init() {
      this.axios.get("/mock/info.json").then((res) => {
        const data = res.data;
        this.data = data.splice(0, 5);
        this.data2 = data.splice(5, 10);
      });
    },
    formatDate() {
      const now = new Date();
      return `${now.getMonth() + 1}月${now.getDate()}日 ${now.getHours()}:${now.getMinutes().toString().padStart(2, '0')}`;
    },
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 收费逻辑
    gopay() {
      alert("请扫码付费2元后可浏览！！！~");
      this.showModal = true;
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
      location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.index {
  margin-top: 100px;
  padding-top: 40px;
  box-sizing: border-box;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 50%, #f8f9fa 100%);
  min-height: 100vh;

  .container {
    max-width: 1200px;
    margin: 0 auto;

    // banner 图
    .banner {
      width: 100%;
      height: 450px;
      border-radius: 15px;
      overflow: hidden;
      position: relative;
      box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
      margin-bottom: 50px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
      }

      .banner-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(135deg, rgba(255, 215, 0, 0.2) 0%, rgba(0, 0, 0, 0.4) 100%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: white;
        text-align: center;

        .banner-title {
          font-size: 48px;
          font-weight: bold;
          margin-bottom: 15px;
          text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
          letter-spacing: 2px;
        }

        .banner-subtitle {
          font-size: 18px;
          letter-spacing: 3px;
          opacity: 0.9;
        }
      }

      &:hover img {
        transform: scale(1.05);
      }
    }

    // 主容器
    .index-con {
      width: 100%;
      display: flex;
      justify-content: space-between;
      gap: 30px;

      // 左侧
      .index-l {
        flex: 0 0 68%;
        background: #ffffff;
        border-radius: 15px;
        padding: 30px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
        border: 1px solid rgba(255, 215, 0, 0.1);

        // 标题层
        .index-title {
          margin-bottom: 30px;
          position: relative;

          h2 {
            font-size: 28px;
            font-weight: bold;
            color: #1a1a1a;
            display: flex;
            align-items: center;
            gap: 10px;
            margin-bottom: 15px;

            i {
              color: #ffd700;
            }
          }

          .title-decoration {
            height: 3px;
            background: linear-gradient(90deg, #ffd700, transparent);
            border-radius: 2px;
          }
        }

        // 循环项
        .list-item {
          margin-bottom: 30px;
          border-radius: 12px;
          overflow: hidden;
          transition: all 0.3s ease;
          border: 1px solid rgba(0, 0, 0, 0.05);

          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 35px rgba(255, 215, 0, 0.15);
            border-color: rgba(255, 215, 0, 0.3);
          }

          .item-content {
            display: flex;
            background: #ffffff;
          }

          // 左侧图片
          .item-img {
            flex: 0 0 200px;
            position: relative;
            overflow: hidden;

            img {
              width: 100%;
              height: 180px;
              object-fit: cover;
              transition: transform 0.3s ease;
            }

            .item-overlay {
              position: absolute;
              top: 10px;
              right: 10px;
              
              .premium-badge {
                background: linear-gradient(135deg, #ffd700, #ffed4e);
                color: #000;
                padding: 4px 12px;
                border-radius: 15px;
                font-size: 12px;
                font-weight: bold;
                box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
              }
            }

            &:hover img {
              transform: scale(1.1);
            }
          }

          // 右侧信息
          .item-info {
            flex: 1;
            padding: 20px;

            // 标题
            .item-title {
              font-size: 20px;
              font-weight: bold;
              color: #1a1a1a;
              margin-bottom: 10px;
              line-height: 1.4;
              cursor: pointer;
              transition: color 0.3s ease;

              &:hover {
                color: #ffd700;
              }
            }

            // 元信息
            .item-meta {
              display: flex;
              align-items: center;
              gap: 15px;
              margin-bottom: 15px;

              .item-tag {
                background: rgba(255, 215, 0, 0.1);
                color: #ffd700;
                padding: 4px 12px;
                border-radius: 12px;
                font-size: 12px;
                border: 1px solid rgba(255, 215, 0, 0.3);
              }

              .item-time {
                color: #666;
                font-size: 14px;
                font-weight: 500;
              }
            }

            // 简介
            .item-jj {
              font-size: 14px;
              line-height: 1.6;
              color: #666;
              margin-bottom: 20px;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }

            // 操作按钮
            .item-action {
              .read-btn {
                background: linear-gradient(135deg, #ffd700, #ffed4e);
                color: #000;
                border: none;
                padding: 8px 20px;
                border-radius: 20px;
                font-weight: bold;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);

                &:hover {
                  transform: translateY(-2px);
                  box-shadow: 0 6px 20px rgba(255, 215, 0, 0.4);
                }
              }
            }
          }
        }
      }

      // 右侧
      .index-r {
        flex: 0 0 32%;
        background: #ffffff;
        border-radius: 15px;
        padding: 30px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
        border: 1px solid rgba(255, 215, 0, 0.1);

        // 标题
        .r-title {
          margin-bottom: 30px;
          position: relative;

          span {
            font-size: 24px;
            font-weight: bold;
            color: #1a1a1a;
            display: flex;
            align-items: center;
            gap: 10px;

            i {
              color: #ff6b6b;
            }
          }

          .title-decoration {
            height: 3px;
            background: linear-gradient(90deg, #ff6b6b, transparent);
            border-radius: 2px;
            margin-top: 10px;
          }
        }

        // 循环项
        .r-item {
          margin-bottom: 25px;
          position: relative;

          .r-content {
            display: flex;
          }

          // 时间线
          .r-timeline {
            flex: 0 0 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 15px;

            .r-dot {
              width: 12px;
              height: 12px;
              background: #ffd700;
              border-radius: 50%;
              border: 3px solid #ffffff;
              box-shadow: 0 0 0 2px #ffd700;
              z-index: 2;
            }

            .r-line {
              flex: 1;
              width: 2px;
              background: linear-gradient(180deg, #ffd700, rgba(255, 215, 0, 0.3));
              margin-top: 5px;
            }

            &:last-child .r-line {
              display: none;
            }
          }

          // 内容
          .r-details {
            flex: 1;
            background: #f8f9fa;
            border-radius: 10px;
            padding: 20px;
            transition: all 0.3s ease;
            border: 1px solid transparent;

            &:hover {
              background: #ffffff;
              border-color: rgba(255, 215, 0, 0.3);
              transform: translateX(5px);
            }

            // 时间
            .r-time {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 10px;

              span {
                font-size: 12px;
                color: #999;

                &:first-child {
                  color: #ffd700;
                  font-weight: 500;
                }

                &.r-date {
                  color: #666;
                }
              }
            }

            // 标题
            .r-name {
              margin-bottom: 10px;

              h3 {
                font-size: 16px;
                font-weight: bold;
                color: #1a1a1a;
                line-height: 1.4;
                cursor: pointer;
                transition: color 0.3s ease;

                &:hover {
                  color: #ffd700;
                }
              }
            }

            // 简介
            .r-jj {
              p {
                font-size: 13px;
                line-height: 1.5;
                color: #666;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
                margin-bottom: 15px;
              }
            }

            // 操作
            .r-action {
              .read-more {
                color: #ffd700;
                font-size: 12px;
                font-weight: 500;
                cursor: pointer;
                transition: all 0.3s ease;

                &:hover {
                  color: #000;
                }
              }
            }
          }
        }
      }
    }
  }
}

// 支付弹窗样式
.payment-content {
  text-align: center;
  padding: 20px;

  .payment-icon {
    font-size: 48px;
    color: #ffd700;
    margin-bottom: 20px;
  }

  .payment-qr {
    width: 200px;
    height: 200px;
    margin: 0 auto 20px;
    border: 2px solid #ffd700;
    border-radius: 10px;
    padding: 10px;
  }

  .payment-text {
    font-size: 18px;
    color: #333;
    margin-bottom: 10px;

    .price {
      color: #ff6b6b;
      font-weight: bold;
      font-size: 24px;
    }
  }

  .payment-desc {
    font-size: 14px;
    color: #666;
  }
}

// 响应式调整
@media (max-width: 1200px) {
  .index .container {
    padding: 0 20px;
  }
}
</style>